import React from 'react';
import { ArrowRight } from 'core/icons';
import StyledLinkCard, { StyledHeading, Group } from './styled/StyledLinkCard';

const CardLink = ({title, compact, ...rest}) => {
  const headingLevel = (
    compact ? 6 : 5
  );

  return (
    <StyledLinkCard
      {...rest}
      compact={compact}
    >
      <Group>
        <StyledHeading
          level={headingLevel}>
          {title}
        </StyledHeading>

        <ArrowRight />
      </Group>
    </StyledLinkCard>
  );
};

export default CardLink;



// WEBPACK FOOTER //
// ./src/elements/Card/CardLink.jsx